"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const NumberParser_1 = __importDefault(require("./NumberParser"));
const Subscription_1 = __importDefault(require("./Subscription"));
const ClientInfo_1 = __importDefault(require("./ClientInfo"));
const Dictionary_1 = __importDefault(require("./Dictionary"));
const Account_1 = __importDefault(require("./Account"));
const Oauth_1 = __importDefault(require("./Oauth"));
class Index {
    constructor(rc, apiVersion = 'v1.0') {
        this.rc = rc;
        this.apiVersion = apiVersion;
    }
    path(withParameter = true) {
        if (withParameter && this.apiVersion !== null) {
            return `/restapi/${this.apiVersion}`;
        }
        return '/restapi';
    }
    /**
     * Returns current API version(s) and server info.
     * HTTP Method: get
     * Endpoint: /restapi
     * Rate Limit Group: NoThrottling
     */
    async list(restRequestConfig) {
        const r = await this.rc.get(this.path(false), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns current API version info by apiVersion.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}
     * Rate Limit Group: NoThrottling
     */
    async get(restRequestConfig) {
        if (this.apiVersion === null) {
            throw new Error('apiVersion must be specified.');
        }
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    oauth() {
        return new Oauth_1.default(this);
    }
    account(accountId = '~') {
        return new Account_1.default(this, accountId);
    }
    dictionary() {
        return new Dictionary_1.default(this);
    }
    clientInfo() {
        return new ClientInfo_1.default(this);
    }
    subscription(subscriptionId = null) {
        return new Subscription_1.default(this, subscriptionId);
    }
    numberParser() {
        return new NumberParser_1.default(this);
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map